import { render, staticRenderFns } from "./TrainingPlanDash.vue?vue&type=template&id=c93dbab8&"
import script from "./TrainingPlanDash.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports